import React from "react";
import "./PassportInstructionIllustration.css";

/**
 * Stylized passport portrait mock — good/bad variants per instruction slide.
 */
const PassportInstructionIllustration = ({ variant = "format-good" }) => (
  <div
    className={`appm-instr-illus appm-instr-illus--${variant}`}
    aria-hidden="true"
  >
    <div className="appm-instr-illus__frame">
      <div className="appm-instr-illus__scene">
        <div className="appm-instr-illus__bg" />
        <div className="appm-instr-illus__shoulders" />
        <div className="appm-instr-illus__neck" />
        <div className="appm-instr-illus__head">
          <div className="appm-instr-illus__hair" />
          <div className="appm-instr-illus__face">
            <span className="appm-instr-illus__eye appm-instr-illus__eye--l" />
            <span className="appm-instr-illus__eye appm-instr-illus__eye--r" />
            <span className="appm-instr-illus__nose" />
            <span className="appm-instr-illus__mouth" />
          </div>
          <div className="appm-instr-illus__glasses" />
          <div className="appm-instr-illus__hat" />
          <div className="appm-instr-illus__shadow" />
        </div>
        <div className="appm-instr-illus__clutter">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  </div>
);

export default PassportInstructionIllustration;
